// extracted by mini-css-extract-plugin
module.exports = {"root":"price_root__1NcfD","amount":"price_amount__1Vsma","period":"price_period__1pYBD","prefix":"price_prefix__2JWjV","light":"price_light__3JV0b","large":"price_large__2McDr"};